import Geocode from "../_snowpack/pkg/react-geocode.js";
import {GOOGLE_MAPS_KEY} from "../constants.js";
export async function geocode(location) {
  const {results} = await Geocode.fromLatLng(location.lat.toString(), location.lng.toString(), GOOGLE_MAPS_KEY);
  console.log("Got Geocode results", results);
  const res = results[0];
  const oriLoc = {
    geometry: {
      location
    }
  };
  return {...res, ...oriLoc};
}
export async function irradiance({lat, lng}) {
  const result = await fetch(`https://api.globalsolaratlas.info/data/lta?loc=${lat},${lng}`, {
    method: "GET",
    headers: {accept: "application/json", "content-type": "application/json"}
  });
  if (result.status < 200 || result.status >= 300) {
    throw new Error(result.statusText);
  }
  const response = await result.json();
  if (!response?.annual?.data) {
    throw new Error("Invalid data");
  }
  const {PVOUT_csi: pvout, DNI: dni, GHI: ghi, DIF: dif, GTI_opta: gtio, OPTA: opta, TEMP: temperature, ELE: elevation} = response.annual.data;
  return {pvout, dni, ghi, dif, gtio, opta, temperature, elevation};
}
